export default "__VITE_ASSET__eab38103__"